import { Formio } from 'formiojs';

const FieldComponent = Formio.Components.components.field;
const editForm = Formio.Components.components.nested.editForm;

let dataComp = {};
const values = [];

export default class SummaryComponent extends FieldComponent {
  static schema(...extend) {
    return FieldComponent.schema(
      {
        type: 'summary',
        label: 'Summary (Draft)',
        key: 'summary',
      },
      ...extend
    );
  }

  static get builderInfo() {
    return {
      title: 'Summary (Draft)',
      icon: 'html',
      group: 'basic',
      documentation: '/userguide/#textfield',
      weight: 0,
      schema: SummaryComponent.schema(),
    };
  }

  constructor(component, options, data) {
    super(component, options, data);
  }

  init() {
    window.isLoaded = false;
    super.init();
  }

  render(_content) {
    const table = '<div id="summaryData"></div>';
    return super.render(table);
  }

  attach(element) {
    // System macht nichts weiter, Widget kümmert sich um das Laden
    return super.attach(element);
  }

  detach() {
    return super.detach();
  }

  destroy() {
    return super.destroy();
  }

  getValue() {
    return super.getValue();
  }

  getValueAt(index) {
    return super.getValueAt(index);
  }

  normalizeValue(value, flags = {}) {
    return super.normalizeValue(value, flags);
  }

  setValue(_value, flags = {}) {
    this.data.sepaCustomizing = values;
    return super.setValue(this.data.sepaCustomizing, flags);
  }

  setValueAt(index, _value, flags = {}) {
    const setValAt = values[index];
    return super.setValueAt(index, setValAt, flags);
  }

  updateValue(_value, _flags = {}) {
    return super.updateValue();
  }
}

Formio.Components.addComponent('summary', SummaryComponent);
